import { client as apolloClient } from '@guuru/graphql-common';
import UPLOAD_CHAT_ATTACHMENT from './mutations/uploadChatAttachment';
import uploadGCSSignedUrl from './uploadGCSSignedUrl';

export default async function (idToken, chatId, {
  filename, mimetype, blob,
}) {
  const client = apolloClient({
    getCurrentUser: () => ({ getIdToken: () => idToken }),
    sha256Fn: () => undefined,
  });
  const {
    data: {
      uploadChatAttachment: {
        writeUrl,
        readUrl,
        maxBytes,
        acl,
      },
    },
  } = await client.mutate({
    mutation: UPLOAD_CHAT_ATTACHMENT,
    variables: {
      id: chatId,
      input: { filename, mimetype },
    },
  });
  await uploadGCSSignedUrl({
    contentType: mimetype,
    writeUrl,
    blob,
    maxBytes,
    acl,
  });

  return { name: filename, url: readUrl };
}
